<template>
  <form class="space-y-4 text-left tracking-wider">
    <div>
      <label class="block text-base font-bold mb-1 uppercase">
        Usuário *
      </label>
      <input
        name="email"
        type="email"
        required
        class="w-full bg-[#404040] text-white px-3 py-2 rounded-sm border border-gray-700 focus:outline-none focus:ring-2 focus:ring-red-700"
        v-model="dataShared.state.cLogin.signIn.email"
      />
    </div>
    <div>
      <label class="block text-base font-bold mb-1 uppercase"
        >Senha *</label
      >

      <div class="relative">
        <input
          v-model="dataShared.state.cLogin.signIn.password"
          :type="inputType"
          class="w-full bg-[#404040] text-white px-3 py-2 rounded-sm border border-gray-700 focus:outline-none focus:ring-2 focus:ring-red-700"
        />

        <label
          @click="togglePasswordVisibility"
          class="absolute top-1/2 transform -translate-y-1/2 cursor-pointer -mr-7"
          :class="[
            isMobile ? 'right-8' : 'right-12'
          ]"
        >
          <PhEye v-if="showPassword" class="text-[#d20a0a] w-7 h-7" />
          <PhEyeClosed v-else class="text-[#d20a0a] w-7 h-7" />
        </label>

      </div>
    </div>

    <button
      type="submit"
      class="w-full py-3 bg-red-700 text-white font-bold uppercase hover:bg-red-800 transition"
      @click.prevent="login()"
    >
      Entrar
    </button>
  </form>
</template>

<script setup>
import SharedService from '@/shared/services/shared'
import { dataShared } from '@/shared/store'
import { showToast as toast } from '@/helpers/UseToasts'
import SignUp from './SignUp.vue'
import { markRaw } from 'vue'
import Events from '../../authenticated/home.vue'
import { PhEye, PhEyeClosed } from '@phosphor-icons/vue'
import { ref } from 'vue'
import { computed } from 'vue'

const showPassword = ref(false)
const inputType = computed(() => (showPassword.value ? 'text' : 'password'))

const togglePasswordVisibility = () => {
  showPassword.value = !showPassword.value
}

async function login () {
  dataShared.dispatch('activeLoading')

  await SharedService.login(dataShared.state.cLogin.signIn)
    .then(res => {
      dataShared.dispatch('desactiveLoading')
      if (res.data.user) {
        dataShared.commit('SET_USER', res.data.user)
      }
      dataShared.dispatch('setComponentActive', markRaw(Events))
      toast('Bem-vindo', res.data.message, 'success')

      // redirect após login e cookie
      window.location.href = `${process.env.VUE_APP_BASE_URL}home`
    })
    .catch(err => {
      dataShared.dispatch('desactiveLoading')

      if (err?.response?.data?.error && err.response.data.status === 400) {
        return toast(
          'Aviso',
          err.response.data.message,
          'error'
        )
      }

      if (err?.response?.data?.error && err.response.data.status === 404) {
        dataShared.dispatch('setComponentActiveLogin', markRaw(SignUp))

        return toast(
          'Aviso',
          err.response.data.message,
          'error'
        )
      }

      if (err?.response?.data?.error && err.response.data.status === 401) {
        return toast(
          'Aviso',
          err.response.data.message,
          'error'
        )
      }

      return toast(
        'Aviso',
        'Algo deu errado com sua solicitação',
        'error'
      )
    })
}

</script>
